import React from "react";

//redirect page component
const RedirectPage = () => {
  return (
    <div>
      <h1>404 Page Not Found </h1>
      <h2>
        You have reached this page because the feature you are looking for is
        still in development
      </h2>
      <h3>
        Check back often because we are working diligently to get it running
      </h3>
    </div>
  );
};

export default RedirectPage;
